<template>
    <client-page class="wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'커뮤니티'"></sub-visual>
        <div class="tab-list--primary-wrap">
            <ul class="tab-list tab-list--primary">
                <li><router-link to="/community/notice" class="button">공지사항</router-link></li>
                <li class="on"><router-link to="/community/reference" class="button">자료실</router-link></li>
                <li><router-link to="/community/qna" class="button">QnA</router-link></li>
            </ul>
        </div>

        <section class="section">
            <v-container>
                <tit-primary
                sc="archive"
                tit="자료실">
                </tit-primary>

                <div class="board-container">
                    <board-list v-if="!_reference" v-bind="boardProps" :writeScope="['console']" />
                    <board-input v-else-if="isWrite" v-bind="boardProps" />
                    <board-view v-else v-bind="boardProps" :_id="_reference" />
                </div>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import BoardList from "@/components/client/board/board-list.vue";
import BoardInput from "@/components/client/board/board-input.vue";
import BoardView from "@/components/client/board/board-view.vue";
import TitPrimary from "@/components/client/dumb/tit-primary.vue";

const boardProps = {
    code: "yfactory-reference",
    skin: "board-reference",
};

export default {
    components: {
        ClientPage,
        SubVisual,
        BoardList,
        BoardInput,
        BoardView,
        TitPrimary,
    },
    props: ["_reference"],
    computed: {
        isWrite() {
            return this._reference == "create";
        },
    },
    data() {
        return {
            boardProps,
        };
    },
};
</script>
